// extracted by mini-css-extract-plugin
export default {"rejectButton":"RejectButton_rejectButton__JaoO4","buttonContainer":"RejectButton_buttonContainer__+BdQl"};